
















































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import { utils, writeFileXLSX } from 'xlsx';
import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import Confirmation from '@/components/Confirmation.vue';
import { eventBus, actionsEvent } from '@/setup';
import HandleErrors from '@/config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { LoadingService } from '@/services/loadingService';
import { fetchConfiguracion } from './fetchConfiguracion';
import CrearAlarma from './CrearAlarma.vue';
import EditarAlarma from './EditarAlarma.vue';
import ModalVerHistorico from './ModalVerHistorico.vue';
import { makeAccionesColumnDef } from '@/reusable/Grid/aggridColumnDefUtils';
@Component({
  components: {
    MantenedorGrid,
    DatePicker,
    Confirmation,
    FormFieldsContainer,
    CrearAlarma,
    EditarAlarma,
    ModalVerHistorico,
  },
})
export default class MantenedorProveedores extends ComponenteBase {
  filtro: any = '';
  ordesList: any[] = [];

  funcionalidad: Funcionalidades = Funcionalidades.ConfiguracionAlarmas;
  estados: Array<String> = ['ACTIVO', 'INACTIVO'];

  formFields: FormFieldDefMap = {
    tipoAlarma: {
      label: 'Tipo Alarma',
      value: '',
      id: '',
    },
    ubicacion: {
      label: 'Ubicación',
      value: '',
      id: '',
    },
    estado: {
      label: 'Estado',
      value: '',
      id: '',
    },
  };

  exportarExcel() {
    let informacionOrdenada = this.ordesList.map((e: any) => {
      return {
        Nombre: e.alarmanombre,
        'Tipo Alarma': e.configdescripcion,
        Ubicación: e.tipoubicaname,
        Condición: e.condicion,
        Cantidad: e.alarmavalor,
        Estado: e.estado,
      };
    });
    const ws = utils.json_to_sheet(informacionOrdenada);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Alarmas');
    writeFileXLSX(wb, 'Alarmas.xlsx');
    this.$snotify.success('Excel Exportado con exito', 3000);
  }

  clearFilters() {
    this.formFields.tipoAlarma.value = '';
    this.formFields.ubicacion.value = '';
    this.formFields.estado.value = '';
  }

  async filtrar() {
    this.ordesList = await this.getAlarmas();
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  async getAlarmas() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracion(
      {
        tipo: this.formFields.tipoAlarma.value || '',
        ubicacion: this.formFields.ubicacion.value || '',
        estado: this.formFields.estado.value || '',
      },
      'conecta_configuracion_alarmas/inicio'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar las alarmas', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getAlarmas();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  showModalNew = false;
  pasoActivoIndex = 1;
  pasoActivoEditar = 1;

  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: false,
  };

  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionCrear,
    this.accionEditar,
  ];

  // Globales
  tabModel: string = 'tab-3';
  dialog: Boolean = false;
  search: string = '';

  gridOptions: GridOptions;

  loadingService = new LoadingService();
  intervalo: any; //Intervalo para el buscador
  chequearPermisosBtnCrear: boolean = true;
  editedIndex: number = -1;

  handleErrors: HandleErrors = new HandleErrors();

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  estadoGrillaVm: EstadoGrillaVm;
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  // Componentes
  //showModalNew: boolean = false;
  showModalEdit: boolean = false;
  modalEsEdicion: boolean = false;

  dateFormatter(params: any) {
    return moment(params.value).format('YYYY/MM/DD');
  }

  constructor() {
    super();
    this.columnDefs = [
      {
        headerName: 'Nombre',
        field: 'alarmanombre',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 300,
        width: 300,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Tipo Alarma',
        field: 'configdescripcion',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 300,
        width: 300,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Ubicación',
        field: 'tipoubicaname',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 300,
        width: 300,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Condición',
        field: 'condicion',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 300,
        width: 300,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Cantidad',
        field: 'alarmavalor',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 180,
        width: 180,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Estado',
        field: 'estado',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 200,
        width: 200,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
        cellRenderer: params => {
          return `<i class="material-icons" title="Anulado" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: ${
            params.data.estado == 'INACTIVO' ? 'rgb(255, 58, 58)' : '#26FF26'
          }"></i>
          <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">
          ${params.data.estado}
          </a>
          `;
        },
      },
      makeAccionesColumnDef(this.funcionalidad),
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 30, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          //cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('YYYY-MM-DD');
  }
  tipos: Array<object> = [];
  ubicaciones: Array<object> = [];
  async getFilters() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracion({}, 'conecta_configuracion_alarmas/get_filters')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.tipos = data.data.TIPOS;
          this.ubicaciones = data.data.UBICACIONES;
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  mounted() {
    this.getFilters();
  }

  created() {
    this.initialize();
  }

  async anular() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracion(
      {
        alarmaId: this.editedItem,
        usuarioId: JSON.parse(localStorage.getItem('user')).id,
        clienteId: JSON.parse(localStorage.getItem('user')).clienteDefecto,
      },
      'conecta_configuracion_alarmas/anular_alarma'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        this.filtrar();
        return null;
      });
  }

  alarmaNombre: string = '';
  verHistorial: boolean = false;
  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (this.funcionalidad === Funcionalidades.ConfiguracionAlarmas) {
        if (
          data.action === Accion.Editar ||
          data.action === Accion.VerHistorico
        ) {
          this.editedItem = null;
          this.modalEsEdicion = data.action == Accion.Editar;
          this.editedIndex = data.id;

          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            this.showModalEdit = data.action === Accion.Editar;
            this.editedItem = data.cellRendererParams.data.alarmaid;
            this.alarmaNombre = data.cellRendererParams.data.alarmanombre;
            this.verHistorial = data.action === Accion.VerHistorico;
          }
        }
      }
    });
  }

  beforeDestroy() {}

  moduloModalCallback(val: boolean) {
    this.showModalNew = val;
    this.showModalEdit = val;
    this.verHistorial = val;
    this.filtrar();
  }

  confirmCallbackConfirm(val: boolean) {
    this.filtrar();
  }
}
